import { apiGet, apiPost, apiPut, API_ENDPOINTS } from "../utils/apiUtils";

/**
 * Price Service
 * Handles product pricing operations
 */
const PriceService = {
  /**
   * Get all prices
   * @returns {Promise} API response
   */
  async getPrice() {
    return apiGet(API_ENDPOINTS.PRICES.GET_ALL);
  },

  /**
   * Update prices
   * @param {Object} priceData - Price update data
   * @returns {Promise} API response
   */
  async updatePrice(priceData) {
    return apiPost(API_ENDPOINTS.PRICES.UPDATE, priceData);
  },

  /**
   * Get vendor boost prices
   * @returns {Promise} API response
   */
  async getVendorBoostPrice() {
    return apiGet(API_ENDPOINTS.VENDOR_BOOST_PRICES.GET_ALL);
  },

  /**
   * Update vendor boost prices
   * @param {Object} priceData - Vendor boost price update data
   * @returns {Promise} API response
   */
  async updateVendorBoostPrice(priceData) {
    return apiPut(API_ENDPOINTS.VENDOR_BOOST_PRICES.UPDATE, priceData);
  },
};

export default PriceService;
